import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import axios from "axios";

import { BsChevronLeft } from "react-icons/bs";

import { calcPrice } from "../shopping/common/function/shopping";
import { CartContainer, Container } from "./component/styled/setting";
import Cart from "./component/menuBoardCart/cart";
import Company from "./component/menuBoardCart/company";
import EditOption from "./component/menuBoardCart/editOption";
import { useDisableScroll } from "../../hooks/useDisableScroll";

const MenuBoardCart = () => {
  const { cmpnyNo } = useParams();
  const navigate = useNavigate();

  const [company, setCompany] = useState(null);
  const [cart, setCart] = useState([]);
  const [selection, setSelection] = useState(null);

  useDisableScroll();

  const formatNumber = (num) => num?.toLocaleString("ko-KR") ?? "0";
  const getTotalPrice = () =>
    Array.isArray(cart) ? cart.reduce((sum, item) => sum + calcPrice(item), 0) : 0;

  const handleOrder = () => {
    navigate(`/menu-board/${cmpnyNo}/order`, {
      state: { items: cart, totalPrice: getTotalPrice() },
    });
  };

  const decryptId = async (id) => {
    const url = "/etc/decrypt-6char";
    const body = { code: id };
    const res = await axios.post(url, body);
    return res.data.plain;
  };

  const isTimestampExpired = () => {
    if (!cmpnyNo) throw new Error("회사번호 없음");
    try {
      const raw = localStorage.getItem(`timestamp:${cmpnyNo}`);
      const saved = raw ? parseInt(raw, 10) : null;

      if (!saved || !Number.isFinite(saved)) throw new Error("세션 만료 시간 없음");
      const elapsed = Date.now() - saved;
      const expired = elapsed > 5 * 60 * 1000;

      if (expired) {
        try {
          alert("세션이 만료되었습니다. 처음 화면으로 이동합니다.");
          localStorage.removeItem(`mbOrderItems:${cmpnyNo}`);
          localStorage.removeItem(`mbTableNo:${cmpnyNo}`);
          localStorage.removeItem(`mbCart:${cmpnyNo}`);

          try {
            window.open("", "_self");
            window.close();
          } catch (e) {}
          navigate("/");
        } catch (e) {}
      }
      return expired;
    } catch (e) {
      console.log(e);
      return false;
    }
  };

  useEffect(() => {
    if (!cmpnyNo) return;
    if (isTimestampExpired()) return;
    getCompany();
  }, [cmpnyNo]);

  const getCompany = async () => {
    const decryptedId = await decryptId(cmpnyNo);
    if (!decryptedId) throw new Error("회사번호 없음");

    const url = "/erp/ss/company/get";
    const body = { cmpnyNo: decryptedId };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        setCompany(res.data);
        getCart();
      }
    } catch (error) {
      console.error("회사 정보 로딩 실패", error);
      navigate("/");
    }
  };

  const getCartKey = () => `mbCart:${cmpnyNo}`;
  const loadCart = () => {
    try {
      const raw = localStorage.getItem(getCartKey());
      const parsed = JSON.parse(raw || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };
  const saveCart = (items) => {
    localStorage.setItem(getCartKey(), JSON.stringify(items || []));
  };
  const getCart = () => {
    setCart(loadCart());
  };

  const handleQtyChange = (index, diff) => {
    const current = loadCart();
    if (index < 0 || index >= current.length) return;

    const item = current[index];
    const newQty = (item.quantity || 1) + diff;
    if (newQty < 1) return;

    const updated = { ...item, quantity: newQty };
    const next = current.map((it, i) => (i === index ? updated : it));
    saveCart(next);
    setCart(next);
  };

  const deleteProduct = (indexes) => {
    const current = loadCart();
    const next = current.filter((item, index) => !indexes.includes(index));
    saveCart(next);
    setCart(next);
  };

  const handleDelete = (index) => {
    deleteProduct([index]);
  };

  return (
    <Container>
      <CartContainer>
        <div className="hd">
          <button
            onClick={() => (selection ? setSelection(null) : navigate(`/menu-board/${cmpnyNo}`))}>
            <BsChevronLeft />
          </button>
          <p>{selection ? "옵션 변경" : "장바구니"}</p>
        </div>
        <div className="content">
          {selection ? (
            <EditOption selection={selection} setSelection={setSelection} getCart={getCart} />
          ) : (
            <>
              <Company company={company} />
              <span className="st">주문 메뉴</span>
              <Cart
                cart={cart}
                setSelection={setSelection}
                handleQtyChange={handleQtyChange}
                handleDelete={handleDelete}
              />
              {getTotalPrice() > 0 && (
                <button className="submit" onClick={() => !isTimestampExpired() && handleOrder()}>
                  {formatNumber(getTotalPrice())}원 주문
                </button>
              )}
            </>
          )}
        </div>
      </CartContainer>
    </Container>
  );
};

export default MenuBoardCart;
